<div class="footer">
    <img [src]="gctiLogo" alt="Grupo de Ciência e Tecnologia da Informação e Inovação">
    <p class="terms"><a href="/#/termos-politicas/termos-servicos" target="_blank">Termos de Serviço</a></p>
    <p class="terms"><a href="/#/termos-politicas/politica-privacidade" target="_blank">Política de Privacidade</a></p>
    <p class="author">&copy; {{currentlyYear}} - Prefeitura Municipal de Parnamirim</p>
</div>
